import React, { useState } from "react";
import { toast } from "sonner";
import { PageHeader } from "@/components/shared";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useI18n } from "@/lib/i18n";

export default function Settings() {
  const { t, lang, setLang } = useI18n();
  const { user, setUser } = useAuth();
  const [emailNotif, setEmailNotif] = useState(user?.email_notifications ?? true);

  const saveNotif = async (val) => {
    setEmailNotif(val);
    const { data } = await api.put("/settings", { email_notifications: val });
    setUser(data); toast.success("Settings saved");
  };
  const saveLang = async (val) => {
    setLang(val);
    await api.put("/settings", { language: val });
    toast.success("Language updated");
  };

  return (
    <div>
      <PageHeader title={t("settings")} subtitle="Preferences and notifications." />
      <div className="ec-card p-6 sm:p-8 space-y-6 max-w-lg">
        <div className="flex items-center justify-between">
          <div><Label>{t("language")}</Label><p className="text-sm text-gray-500">English / <span className="text-gray-300">اردو</span></p></div>
          <div className="flex gap-2">
            <Button onClick={() => saveLang("en")} data-testid="settings-lang-en" className={lang === "en" ? "bg-orange-600" : "bg-white/5 border border-white/10"}>English</Button>
            <Button onClick={() => saveLang("ur")} data-testid="settings-lang-ur" className={lang === "ur" ? "bg-orange-600" : "bg-white/5 border border-white/10"}>اردو</Button>
          </div>
        </div>
        <div className="flex items-center justify-between border-t border-white/5 pt-6">
          <div><Label>{t("email_notifications")}</Label><p className="text-sm text-gray-500">Receive result & reward emails</p></div>
          <Switch checked={emailNotif} onCheckedChange={saveNotif} data-testid="settings-email-notif" />
        </div>
      </div>
    </div>
  );
}
